import { BEValueObject } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEValueObjectExtend {
  public static Init(dto: BEValueObject) {
    dto.bEType = EnumBEType.BEValueObject;
  }
}
